import { Controller } from "@hotwired/stimulus"

export default class extends Controller<HTMLElement> {
  static targets = ["locked", "unlocked"]
  static values = { cookie: String }

  declare readonly lockedTarget: HTMLElement
  declare readonly unlockedTarget: HTMLElement
  declare readonly cookieValue: string

  connect() {
    // The markup can arrive after the cookie was created, e.g. a frame still loading at that moment.
    if (this.cookieExists()) this.unlock()
  }

  unlock() {
    this.lockedTarget.hidden = true
    this.unlockedTarget.hidden = false
  }

  private cookieExists() {
    return document.cookie.split("; ").some((cookie) => cookie.startsWith(`${this.cookieValue}=`))
  }
}
